<template>
  <div class="">
    <Header />
    <div class="container d-flex justify-content-center">
      <otpForm />
    </div>
  </div>
</template>

<script>
import Header from "@/components/layout/utils/Header";
import otpForm from "@/components/otpForm";

export default {
  name: "userLogin",
  components: { Header, otpForm },
};
</script>

<style lang="scss" scoped></style>
